import { render, staticRenderFns } from "./RelationManage.vue?vue&type=template&id=02ca4546&scoped=true"
import script from "./RelationManage.vue?vue&type=script&lang=js"
export * from "./RelationManage.vue?vue&type=script&lang=js"
import style0 from "./RelationManage.vue?vue&type=style&index=0&id=02ca4546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca4546",
  null
  
)

export default component.exports